/**
 * Componente de cambio de contraseña: Muestra el formulario de cambio de contraseña
 */

import { Box, Button, Description, Heading, Input, Label, Stack, StackRow, shootToast } from "codekit";

import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Pwdrules from "../../components/Pwdrules/Pwdrules";

import { useRestorePasswordMutation } from "../../libs/redux/slices/forgotSlice/forgotApiSlice";
import { getPasswordStrength, setPasswordStrength } from "../../libs/redux/slices/passwordSlice/passwordSlice";
import {
  getUser as getUserForgot,
  showSuccessMessage as showSuccessMessageForgot,
  reset,
} from "../../libs/redux/slices/forgotSlice/forgotSlice";
import {
  getUser as getUserAuth,
  getPasswordFormMessage,
  showSuccessMessage as showSuccessMessageAuth,
  signOut,
} from "../../libs/redux/slices/authSlice/authSlice";
import { useLogoutMutation } from "../../libs/redux/slices/authSlice/authApiSlice";

const Changpwd = ({ origin, isSmallScreen }) => {
  const isLoginRequest = origin === "LOGIN-PAGE";
  const isForgotPasswordRequest = origin === "FORGOT-PAGE";

  const USRIDXXX = useSelector(isLoginRequest ? getUserAuth : getUserForgot);

  const passwordStrength = useSelector(getPasswordStrength);
  const passwordFormMessage = useSelector(getPasswordFormMessage);
  const [logout] = useLogoutMutation();

  const { isPasswordStrong } = passwordStrength;

  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
    watch,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      password: "",
      passwordConfirm: "",
    },
  });

  const password = watch("password");
  const passwordConfirm = watch("passwordConfirm");

  const [restorePassword, { isLoading }] = useRestorePasswordMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPasswordStrength(password || ""));
  }, [dispatch, password]);

  let title = "";
  let paragraph = "";

  if (isLoginRequest) {
    title = passwordFormMessage || "Cambiar contraseña";
    paragraph =
      "Es el momento de cambiar tu contraseña. Recuerda escoger una contraseña fuerte y no guardarlo en sitios inseguros.";
  }

  if (isForgotPasswordRequest) {
    title = "Cambiar contraseña";
    paragraph = `Recuerda crear una contraseña fuerte y no guardarla en sitios inseguros.`;
  }

  const arePasswordEqual =
    (password ?? "") !== "" &&
    (passwordConfirm ?? "") !== "" &&
    password === passwordConfirm;

  const isFormValid = isValid && arePasswordEqual && isPasswordStrong;

  const onSubmit = async (formData) => {
    const { password } = formData;

    try {
      await restorePassword({ USRIDXXX, password }).unwrap();

      if (isLoginRequest) {
        dispatch(signOut());
        await logout();
        dispatch(showSuccessMessageAuth(true));
      } else {
        dispatch(reset());
        dispatch(showSuccessMessageForgot(true));
      }
    } catch (error) {
      // El backend rechaza p. ej. una contraseña ya usada (últimas 24): mostrarlo, no tragarlo
      shootToast({
        variant: "error",
        text:
          error?.data?.errors?.message ||
          error?.data?.errors?.exception ||
          "No se pudo cambiar la contraseña. Inténtalo de nuevo.",
        duration: 8000,
        autoHide: true,
      });
    }
  };

  return (
    <>
      <Box textAlign="center" mb={8}>
        <Stack gap={8}>
          <Heading variant="heading-6">Cambiar contraseña</Heading>
          <Description variant="description-2">
            Recuerda crear una contraseña fuerte y no guardarlos en sitio inseguros.
          </Description>
        </Stack>
      </Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack gap={8}>
          <StackRow>
            <Label htmlFor="password">Contraseña</Label>
            <Input
              id="password"
              type="password"
              disabled={isLoading}
              placeholder="Contraseña"
              style={{ textTransform: "none" }}
              isInvalid={errors.password}
              {...register("password", { required: true })}
            />
          </StackRow>

          <StackRow>
            <Label htmlFor="passwordConfirm">Repetir contraseña</Label>
            <Input
              id="passwordConfirm"
              type="password"
              disabled={isLoading}
              placeholder="Repetir Contraseña"
              style={{ textTransform: "none" }}
              isInvalid={errors.passwordConfirm}
              {...register("passwordConfirm", { required: true })}
            />
          </StackRow>

          {isSmallScreen && (
              <StackRow>
                <Pwdrules />
              </StackRow>
            )}
          <Button disabled={!isFormValid} type="submit" variant="primary-bold" isLoading={isLoading} isFull>
            Validar
          </Button>
        </Stack>
      </form>
    </>
  );
};

export default Changpwd;
